import { render, staticRenderFns } from "./StudentRatingConditionSettingPage.vue?vue&type=template&id=fcdba22e"
import script from "./StudentRatingConditionSettingPage.vue?vue&type=script&lang=js"
export * from "./StudentRatingConditionSettingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports